import { Injectable, inject } from '@angular/core';

import { BizDateRepository } from '@VineyardLib/state/biz-date.repository';

@Injectable({ providedIn: 'root' })
export class BizDateService {
  private repository = inject(BizDateRepository);

  set bizDate(value: string) {
    this.repository.data = value;
  }

  get formatYyyyMmDdString(): string {
    return this.repository.string;
  }

  get date(): Date {
    return this.repository.date;
  }
}
